import React, { useState, useEffect } from 'react';
import {
  // makeStyles,
  Grid,
  TextField,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  FormHelperText,
  Button,
  Dialog,
  Box,
  DialogContent,
  CircularProgress,
  Typography,
} from '@material-ui/core';
import { Formik } from 'formik';
import PropTypes from 'prop-types';
import * as Yup from 'yup';
import { stringConstants } from '../../constants/stringConstants';
import {
  globalDateEntity,
  globalPageTypeEntity,
} from '../../constants/applicationConstants';
import styles from './dialogProceduresAddUpdate.module.scss';
import { useStoreState, useStoreActions } from 'easy-peasy';
import moment from 'moment';

const ProceduresAddUpdate = (props) => {
  const {
    heading,
    dialogType,
    onCloseDialog,
    currentRowData,
    onChangeDialogType,
    ...other
  } = props;

  const orgId = useStoreState((state) => state.organization.organizationId);
  const proceduresAction = useStoreActions((actions) => actions.procedures);
  const comonAction = useStoreActions((actions) => actions.common);
  const proceduresState = useStoreState((state) => state.procedures);
  // Initialize FORM Values
  const initializeFieldData = {
    record_number: '',
    title: '',
    record_type: '',
    category: '',
    current_status: '',
    description: '',
  };
  const [fieldData, setFieldData] = useState(initializeFieldData);
  const [submitLoader, setSubmitLoader] = React.useState(false);

  // Validation Schema for formik
  const schema = Yup.object().shape({
    record_number: Yup.string()
      .max(30, `Code ${stringConstants.twentyCharLimitValidMsg}`)
      .required(stringConstants.requiredValidationMsg),
    title: Yup.string()
      .max(200, `Name ${stringConstants.twoHundredCharLimitValidMsg}`)
      .required(stringConstants.requiredValidationMsg),
    record_type: Yup.string().required(stringConstants.requiredValidationMsg),
    category: Yup.string()
      .max(200, `Category ${stringConstants.twoHundredCharLimitValidMsg}`)
      .required(stringConstants.requiredValidationMsg),
    current_status: Yup.string().required(
      stringConstants.requiredValidationMsg,
    ),
    description: Yup.string()
      .nullable()
      .max(500, `Description ${stringConstants.fiveHundredCharLimitValidMsg}`),
  });

  // On Form Submission Handler
  const onFormSubmit = async (values, { resetForm, setErrors }) => {
    setSubmitLoader(true);
    const { PK, SK, effectivedate, inactivedate, ...temp } = values;
    //If form values has id set then its a update
    if (PK && dialogType === globalPageTypeEntity.edit) {
      proceduresAction
        .updateProcedures({
          orgs_id: orgId,
          ...temp,
          PK,
          SK,
          effectivedate: moment(effectivedate).format(
            globalDateEntity.dateTimeFormatPost,
          ),
          inactivedate: inactivedate
            ? moment(inactivedate).format(globalDateEntity.dateTimeFormatPost)
            : null,
        })
        .then(function (response) {
          setSubmitLoader(false);
          let updatedState = proceduresState.proceduresList.map((item) => {
            if (item.PK === response?.data?.data?.PK) {
              return response?.data?.data;
            }
            return item;
          });
          proceduresAction.setProceduresList(updatedState);
          comonAction.setSubmitSnackbar({
            status: true,
            messages: stringConstants.updateMsg,
          });
          onCloseDialog();
        })
        .catch(function (error) {
          setSubmitLoader(false);
          if (
            error.response &&
            error.response.data &&
            error.response.data.error
          ) {
            let outputErrors = {};
            const errorlist = error.response.data.error;
            for (let item in errorlist) {
              outputErrors[Object.keys(errorlist[item])] =
                errorlist[item][Object.keys(errorlist[item])];
            }
            setErrors(outputErrors);
          }
        });
    } else {
      await proceduresAction
        .addProcedures({
          orgs_id: orgId,
          ...temp,
          effectivedate: moment(effectivedate).format(
            globalDateEntity.dateTimeFormatPost,
          ),
          inactivedate: inactivedate
            ? moment(inactivedate).format(globalDateEntity.dateTimeFormatPost)
            : null,
        })
        .then(function (response) {
          setSubmitLoader(false);
          resetForm();
          proceduresAction.setProceduresList([
            response.data.data,
            ...proceduresState.proceduresList,
          ]);
          comonAction.setSubmitSnackbar({
            status: true,
            messages: stringConstants.addedRecordMsg,
          });
          onCloseDialog();
        })
        .catch(function (error) {
          setSubmitLoader(false);
          if (
            error.response &&
            error.response.data &&
            error.response.data.error
          ) {
            let outputErrors = {};
            const errorlist = error.response.data.error;
            for (let item in errorlist) {
              outputErrors[Object.keys(errorlist[item])] =
                errorlist[item][Object.keys(errorlist[item])];
            }
            setErrors(outputErrors);
          }
        });
    }
  };

  useEffect(() => {
    if (dialogType === globalPageTypeEntity.add) {
      setFieldData(initializeFieldData);
    } else {
      currentRowData.current_status = currentRowData.current_status
        ? currentRowData.current_status
        : 'INACTIVE';
      currentRowData.category = currentRowData.category
        ? currentRowData.category
        : '';
      setFieldData(currentRowData);
    }
  }, [dialogType, currentRowData]);

  return (
    <Dialog
      disableBackdropClick
      disableEscapeKeyDown
      maxWidth="md"
      aria-labelledby="confirmation-dialog-title"
      open={open}
      PaperProps={{
        style: { borderRadius: 20 },
      }}
      {...other}
    >
      <Formik
        initialValues={fieldData}
        onSubmit={onFormSubmit}
        validationSchema={schema}
        enableReinitialize={true}
      >
        {(formikProps) => {
          const {
            values,
            touched,
            dirty,
            errors,
            setFieldValue,
            handleBlur,
            handleSubmit,
            resetForm,
          } = formikProps;
          return (
            <form onSubmit={handleSubmit} noValidate>
              <Box className={styles.dialogmainwrapper}>
                <DialogContent>
                  <Grid container spacing={2} className={`addNewForm`}>
                    <Grid item md={12} xs={12}>
                      <Typography variant="h6" component="h6">
                        {heading}
                      </Typography>
                    </Grid>
                    <Grid item md={4} xs={12}>
                      <TextField
                        disabled={dialogType === globalPageTypeEntity.view || dialogType === globalPageTypeEntity.edit}
                        required
                        fullWidth
                        id="record_number"
                        name="record_number"
                        value={values.record_number}
                        onChange={(e, v) => {
                          setFieldValue('record_number', e.target.value, true);
                        }}
                        onBlur={handleBlur}
                        error={errors.record_number && touched.record_number}
                        helperText={
                          errors.record_number &&
                          touched.record_number &&
                          errors.record_number
                        }
                        label="Code"
                        variant="outlined"
                      />
                    </Grid>
                    <Grid item md={8} xs={12}>
                      <TextField
                        disabled={dialogType === globalPageTypeEntity.view}
                        required
                        fullWidth
                        id="title"
                        name="title"
                        value={values.title}
                        //onChange={handleChange}
                        onChange={(e, v) => {
                          setFieldValue('title', e.target.value, true);
                        }}
                        onBlur={handleBlur}
                        error={errors.title && touched.title}
                        helperText={
                          errors.title && touched.title && errors.title
                        }
                        label="Name"
                        variant="outlined"
                      />
                    </Grid>
                    <Grid item md={4} xs={12}>
                      <FormControl
                        disabled={dialogType === globalPageTypeEntity.view}
                        required
                        variant="outlined"
                        fullWidth
                      >
                        <InputLabel id="demo-simple-select-outlined-label">
                          Status
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-outlined-label"
                          id="demo-simple-select-outlined"
                          placeholder="Status"
                          name="current_status"
                          value={values.current_status}
                          error={
                            errors.current_status && touched.current_status
                          }
                          //onChange={handleChange}
                          onChange={(e, v) => {
                            setFieldValue(
                              'current_status',
                              e.target.value,
                              true,
                            );
                          }}
                          label="Status"
                        >
                          <MenuItem value="ACTIVE">Active</MenuItem>
                          <MenuItem value="INACTIVE">Inactive</MenuItem>
                        </Select>
                        <FormHelperText
                          className={
                            errors.current_status &&
                            touched.current_status &&
                            errors.current_status
                              ? 'Mui-error'
                              : ''
                          }
                        >
                          {errors.current_status &&
                            touched.current_status &&
                            errors.current_status}
                        </FormHelperText>
                      </FormControl>
                    </Grid>
                    <Grid item md={3} xs={12}>
                      <FormControl
                        disabled={dialogType === globalPageTypeEntity.view}
                        required
                        variant="outlined"
                        fullWidth
                      >
                        <InputLabel id="demo-simple-select-outlined-label">
                          Record Type
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-outlined-label"
                          id="demo-simple-select-outlined"
                          placeholder="Record Type"
                          name="record_type"
                          value={values.record_type}
                          error={errors.record_type && touched.record_type}
                          //onChange={handleChange}
                          onChange={(e, v) => {
                            setFieldValue('record_type', e.target.value, true);
                          }}
                          label="Record Type"
                        >
                          <MenuItem value="">
                            <em>None</em>
                          </MenuItem>
                          <MenuItem value="HCPC">HCPC</MenuItem>
                          <MenuItem value="CPT">CPT</MenuItem>
                          <MenuItem value="UB-04 Rev">UB-04 Rev</MenuItem>
                          <MenuItem value="CDT">CDT</MenuItem>
                          <MenuItem value="CPTPLA">CPTPLA</MenuItem>
                          
                        </Select>
                        <FormHelperText
                          className={
                            errors.record_type &&
                            touched.record_type &&
                            errors.record_type
                              ? 'Mui-error'
                              : ''
                          }
                        >
                          {errors.record_type &&
                            touched.record_type &&
                            errors.record_type}
                        </FormHelperText>
                      </FormControl>
                    </Grid>
                    <Grid item md={5} xs={12}>
                      <TextField
                        disabled={dialogType === globalPageTypeEntity.view}
                        required
                        fullWidth
                        id="category"
                        name="category"
                        value={values.category}
                        //onChange={handleChange}
                        onChange={(e, v) => {
                          setFieldValue('category', e.target.value, true);
                        }}
                        onBlur={handleBlur}
                        error={errors.category && touched.category}
                        helperText={
                          errors.category && touched.category && errors.category
                        }
                        label="Category"
                        variant="outlined"
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        disabled={dialogType === globalPageTypeEntity.view}
                        multiline
                        minRows="3"
                        fullWidth
                        id="description"
                        name="description"
                        variant="outlined"
                        value={values.description ? values.description : ''}
                        //onChange={handleChange}
                        onChange={(e, v) => {
                          setFieldValue('description', e.target.value, true);
                        }}
                        onBlur={handleBlur}
                        label="Description"
                        error={errors.description && touched.description}
                        helperText={
                          errors.description &&
                          touched.description &&
                          errors.description
                        }
                      />
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    direction="row"
                    justifyContent="center"
                    alignItems="center"
                    spacing={2}
                    className={styles.btns}
                  >
                    <Grid item>
                      <Button
                        onClick={() => {
                          resetForm();
                          onCloseDialog();
                        }}
                        variant="contained"
                        color="secondary"
                      >
                        Cancel
                      </Button>
                    </Grid>

                    <Grid item>
                      {dialogType === globalPageTypeEntity.view && (
                        <Button
                          onClick={() => {
                            onChangeDialogType();
                          }}
                          variant="contained"
                          color="primary"
                        >
                          Edit
                        </Button>
                      )}
                      {dialogType !== globalPageTypeEntity.view && (
                        <Button
                          type="submit"
                          variant="contained"
                          color="primary"
                          disabled={
                            submitLoader ||
                            (dialogType === globalPageTypeEntity.edit && !dirty)
                          }
                        >
                          {submitLoader && (
                            <CircularProgress
                              size={20}
                              color="white"
                              style={{ marginRight: '5px' }}
                            />
                          )}
                          Save
                        </Button>
                      )}
                    </Grid>
                  </Grid>
                </DialogContent>
              </Box>
            </form>
          );
        }}
      </Formik>
    </Dialog>
  );
};
ProceduresAddUpdate.propTypes = {
  open: PropTypes.bool.isRequired,
  heading: PropTypes.string.isRequired,
  dialogType: PropTypes.string.isRequired,
  currentRowData: PropTypes.object,
};
ProceduresAddUpdate.defaultProps = {
  currentRowData: {},
};
export default ProceduresAddUpdate;
